/**
 * 開発設定の異なるデータ型を表すEnum。
 *
 * @enum {number}
 */
export const DevSettingDataType = Object.freeze({
  /**
   * 文字列データ型を表します。
   * @type {number}
   */
  STRING: 0,
  /**
   * バイトデータ型を表します。
   * @type {number}
   */
  BYTE: 1,
  /**
   * 整数データ型を表します。
   * @type {number}
   */
  INT: 2,
  /**
   * ロングデータ型を表します。
   * @type {number}
   */
  LONG: 3,
  /**
   * ブールデータ型を表します。
   * @type {number}
   */
  BOOLEAN: 4,
  /**
   * リストデータ型を表します。
   * @type {number}
   */
  LIST: 5,
  /**
   * マップデータ型を表します。
   * @type {number}
   */
  MAP: 6,
  /**
   * ショートデータ型を表します。
   * @type {number}
   */
  SHORT: 7,
  /**
   * テキストエリアデータ型を表します。
   * @type {number}
   */
  TEXT_AREA: 8
})



// WEBPACK FOOTER //
// ./src/enums/dev-setting-data-type.enums.js